const readFileAsText = (file: File): Promise<string> => file.text();

export const validateTxtCaracters = async (acceptedFiles: File[]) => {
  return await Promise.all(
    acceptedFiles
      .filter((file) => file.name.toLowerCase().endsWith(".txt"))
      .map(async (file) => {
        const text = await readFileAsText(file);
        // Normalize line endings - replace CRLF (\r\n) with LF (\n)
        const normalizedText = text.replaceAll("\r\n", "\n").replaceAll("\r", "\n");
        return { name: file.name, characters: normalizedText.length };
      })
  );
};
